<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">Benefício Entregues</h1>
    </div>
    <load mode="table" v-if="loadingBeneficios" />
    <div class="col-md-12" v-else>
      <!--Tabela-->
      <div class="row">
        <div class="col-md-12">
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <b-link
                          class="btn btn-default"
                          @click="$router.push('/dashboard/beneficios')"
                          v-b-tooltip.hover
                          title="Voltar para Gestão de Benefícios"
                        >
                          <i class="mdi mdi-arrow-left" />
                        </b-link>

                        <b-button-group>
                          <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                          >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                          </b-button>

                          <button class="btn btn-info" @click="printLista">
                            <i class="fas fa-print" />
                            {{ $t("Lista de assinatura") }}
                          </button>
                          <b-button variant="outline-dark" @click="print()">
                            <i class="fas fa-print"></i>
                          </b-button>
                          <b-button
                            v-b-tooltip.hover
                            :title="$t('Exportar')"
                            variant="outline-dark"
                            @click="exportar()"
                          >
                            <i class="fas fa-file-excel"></i>
                          </b-button>
                        </b-button-group>
                      </div>
                    </div>

                    <div class="col-12" v-if="viewFilterReport">
                      <!-- Filtros -->
                      <form @submit.prevent="getBeneficios" ref="addItem">
                        <div class="row">
                          <form-select
                            v-model="filtroUnidades"
                            label="Unidade(s)"
                            grid="12"
                            :itens="unidades"
                            :disabled="desabledSearchUnidade"
                            :loading="loadingSearchUnidade"
                            multiple
                            @input="getTecnicos()"
                          />

                          <form-calendar
                            v-model="data_inicio"
                            grid="6"
                            label="Data Inicial"
                          />

                          <form-calendar
                            v-model="data_fim"
                            grid="6"
                            label="Data Final"
                            :required="verificaDataInicial"
                          />
                          <div class="col-md-12">
                            <label><b>Pesquisar</b></label>
                            <div class="input-group">
                              <b-input
                                placeholder="Responsável Família,CPF e NIS"
                                class="form-control search-input"
                                type="text"
                                v-model="search"
                                aria-describedby="input-search"
                              />
                              <div
                                class="input-group-append"
                                role="button"
                                @click.prevent="getBeneficios"
                              >
                                <span class="input-group-text" id="input-search"
                                  ><i class="fas fa-search search-icon"
                                /></span>
                              </div>
                            </div>
                            <p class="small text-muted">
                              No campo acima você pode pesquisar por:
                              Responsável Família,CPF e NIS
                            </p>
                          </div>
                        </div>
                        <div
                          class="row pt-4 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default"
                              @click.prevent="
                                limparFiltros(), (viewFilterReport = false)
                              "
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>

                            <button
                              class="btn btn-success btn-submit"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Gerar Relatório") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <print-content>
                        <b-table
                          :fields="[
                            {
                              key: 'entrega',
                              label: $t('Entrega'),
                            },
                            {
                              key: 'data_concessao',
                              label: $t('Concessão'),
                            },
                            {
                              key: 'data_entrega',
                              label: $t('Retirada'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="beneficiosList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="md"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(entrega)="data">
                            <span class="d-block">
                              Benefício:
                              <b>{{ data.item.beneficio_nome }}</b
                              ><br />
                              <span>
                                Responsável Família:
                                <b>{{
                                  data.item.familia.responsavel_familiar
                                    .nome_completo
                                }}</b
                                ><br />
                              </span>
                              <span>
                                Nome de quem retirou:
                                <b>{{ data.item.nome_recepetor }}</b
                                ><br />
                              </span>
                              <span>
                                CPF de quem retirou:
                                <b>{{
                                  data.item.cpf_recepetor
                                    ? data.item.cpf_recepetor
                                    : data.item.familia.responsavel_familiar
                                        .documento.cpf
                                }}</b
                                ><br />
                              </span>
                              <span v-if="data.item.beneficio.quantidade > 0">
                                Quantidade Geral:
                                <b>{{ data.item.beneficio.quantidade }}</b
                                ><br />
                              </span>
                              <span v-if="data.item.quantidade_entrega > 0">
                                Quantidade Entregue:
                                <b>{{ data.item.quantidade_entrega }} </b>
                                <br />
                              </span>
                              <span v-if="data.item.periodicidade"
                                >Periodicidade:
                                <b>{{
                                  getValue(
                                    data.item.periodicidade,
                                    $root.arrays.beneficio_periodicidade
                                  )
                                }}</b></span
                              >
                            </span>
                            <span class="d-block">
                              Usuário:
                              <b>
                                {{
                                  data.item.usuario
                                    ? data.item.usuario.nome_completo
                                    : data.item.familia.responsavel_familiar
                                        .nome_completo
                                }}
                              </b>
                            </span>
                          </template>

                          <template v-slot:cell(data_concessao)="data">
                            {{ data.item.beneficio.created_at | formatDate }}
                          </template>
                          <template v-slot:cell(data_entrega)="data">
                            {{ data.item.data_entrega | formatDate }}
                          </template>

                          <template v-slot:cell()="data">
                            <button
                              @click="
                                redirectBeneficio(
                                  data.item.beneficio.id,
                                  data.item.familia.id
                                )
                              "
                              class="px-2 mb-0 btn btn-sm btn-success my-1 d-flex justify-content-start"
                              v-b-popover.hover.top="'Abrir Benefício'"
                            >
                              <i class="mdi mdi-open-in-new" />
                            </button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getBeneficios"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>

                        <div class="box-btn-print no-print">
                          <b-button
                            v-if="!loadingBeneficios"
                            :title="$t('Visualizar e Imprimir')"
                            class="py-2"
                            size="sm"
                            type="button"
                            v-b-tooltip.hover
                            variant="primary"
                            @click="print()"
                          >
                            <i class="fas fa-print"></i>
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "beneficios",
  metaInfo() {
    return {};
  },
  data() {
    return {
      familia: {},
      unidades: [],
      filtroUnidades: [],
      beneficio: "",
      is_entregue: false,
      status_anterior: false,
      TipobeneficiosList: [],
      beneficiosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingBeneficios: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      isGestor: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      filtroStatusConcessao: null,
      filtroStatusParecer: null,
      filtroDatas: [],
      tecnicos_selected: [],
    };
  },
  mounted() {
    this.getBeneficios();
    this.getTecnicos();
    this.getUnidades();
  },
  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      return map;
    },
  },
  updated() {
    let role_user = this.$store.state.user.role_details.name;
    this.isGestor =
      this.$store.state.user.permissions["BeneficioController"] == true ||
      role_user == "Admin"
        ? true
        : false;
    if (this.isGestor == false) {
      this.redirectBeneficioIndex();
    }
  },
  methods: {
    getValue(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    selectTecicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      this.tecnicos_selected = map;
    },
    getBeneficios() {
      this.loadingBeneficios = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/beneficios/entregues", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroUnidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.beneficiosList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getBeneficios();
          } else {
            this.loadingBeneficios = false;
          }
        })
        .catch(() => {
          this.loadingBeneficios = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/beneficios/entregues", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    printLista() {
      this.loadingBeneficios = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O arquivo será exportado em formato CSV baseado na paginação atual.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/beneficios/entregues/pdf/assinatura", {
          params: {
            page: this.page,
            search: this.search,
            filtroDatas: this.filtroDatas,
          },
        })
        .then((response) => {
          this.loadingBeneficios = false;
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .catch(() => {
          this.loadingBeneficios = false;
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getBeneficios();
      }
    },
    redirectBeneficio(id, familia_id) {
      this.$router.push({
        path: `/dashboard/familia/beneficio/edit/${id}`,
        query: { familia_id: familia_id },
      });
    },
    redirectBeneficioIndex() {
      this.$router.push({
        path: `/dashboard/beneficios`,
      });
    },

    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getTecnicos() {
      this.tecnicos = [];
      this.loadingSearchTecnicos = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.tecnicos = response.data;
          this.selectTecicos();
        })
        .finally(() => (this.loadingSearchTecnicos = false));
    },

    limparFiltros() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.getBeneficios();
    },
  },
};
</script>
